import { render, staticRenderFns } from "./AccountSearchProfession.vue?vue&type=template&id=128f61dc&"
import script from "./AccountSearchProfession.vue?vue&type=script&lang=js&"
export * from "./AccountSearchProfession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports